/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CallidusBvsVersicherungssummeKunde {
    Versicherungssumme5Mio = 'Versicherungssumme5Mio',
    Versicherungssumme10Mio = 'Versicherungssumme10Mio'
  }

    export const CallidusBvsVersicherungssummeKundeTranslocoMap: Record<CallidusBvsVersicherungssummeKunde, string> = {
    [CallidusBvsVersicherungssummeKunde.Versicherungssumme5Mio]: 'callidusBvsVersicherungssummeKunde.versicherungssumme5Mio',
    [CallidusBvsVersicherungssummeKunde.Versicherungssumme10Mio]: 'callidusBvsVersicherungssummeKunde.versicherungssumme10Mio',
    };

    export const CallidusBvsVersicherungssummeKundeOptions = [
  { value: CallidusBvsVersicherungssummeKunde.Versicherungssumme5Mio, labelKey: 'callidusBvsVersicherungssummeKunde.versicherungssumme5Mio' },
  { value: CallidusBvsVersicherungssummeKunde.Versicherungssumme10Mio, labelKey: 'callidusBvsVersicherungssummeKunde.versicherungssumme10Mio' },
    ];

